module.exports = __webpack_public_path__ + "img/logo.404ecab8.svg";